import {Activity, ActivityStreamId, CreateComment, ListActivitiesArgs} from "../Types";
import {invalidateQueries, q} from "../state";
import {CURRENT_REGION} from "../utils/region";
import jsonApi from "./jsonApi";

export async function list(activityStreamId: ActivityStreamId, args: ListActivitiesArgs) {
  return await jsonApi.get<Activity[]>(
    `/region/${CURRENT_REGION}/api/activity_streams/${activityStreamId}/activities?${jsonApi.encodeQuery(args)}`,
  );
}

export async function comment(activityStreamId: ActivityStreamId, comment: CreateComment) {
  const res = await jsonApi.post<"ok">(
    `/region/${CURRENT_REGION}/api/activity_streams/${activityStreamId}/comment`,
    comment,
  );
  await invalidateQueries([q.vendorToolkit.watchingQuestion.filter()]);
  return res;
}
